import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { envConfigSelectors } from '~/components';

export const PhoneNumberInfo = ({
  extra = <p>We&apos;ll send you a text to confirm your booking.</p>,
}) => extra;

PhoneNumberInfo.propTypes = {
  extra: PropTypes.node,
};

export const mapStateToProps = (state) => ({
  extra: envConfigSelectors.selectPhoneNumberInfoExtra(state),
});

export const ConnectedPhoneNumberInfo = connect(mapStateToProps)(PhoneNumberInfo);
